import { Label } from '@/components/ui/label'
import { PaymentRow } from './PaymentRow'
import { renderDatetimeInline } from '@/components/features/shared/utils'
import { PaymentStatus } from '@/domain/payments/payments'

interface PaymentRowInfoProps {
  payment: PaymentRow
}

export const PaymentRowInfo = ({ payment }: PaymentRowInfoProps) => (
  <div className="space-y-1">
    <div className="text-sm">
      <Label className="ml-0">Rubro:</Label>{' '}
      <span className="font-medium">
        {payment.__context.offeringCode} - {payment.__context.offeringName}
      </span>
    </div>
    <div className="text-sm">
      <Label className="ml-0">Concepto:</Label>{' '}
      <span className="font-mono font-bold">{payment.__context.label}</span>
    </div>
    <div className="text-sm">
      <Label className="ml-0">Período de pago:</Label>{' '}
      <span className="font-mono font-bold">{payment.__context.periodDate}</span>
    </div>
    {(payment.status === PaymentStatus.COMPLETED || payment.status === PaymentStatus.IN_COLLECTOR) && <div className="text-sm flex items-center gap-1">
      <Label className='ml-0'>Fecha de pago: </Label>
      <span className=''>{renderDatetimeInline(payment.paymentDate)}</span>
    </div>}
  </div>
)
